import DraftJS from 'draft-js'

export const convertToRaw = (contentState: DraftJS.ContentState) =>
  DraftJS.convertToRaw(contentState)

export const convertFromRaw = (rawState: DraftJS.RawDraftContentState) =>
  DraftJS.convertFromRaw(rawState)

export const createEmptyContent = () => DraftJS.EditorState.createEmpty()

export const editorStateFromRaw = (rawState: DraftJS.RawDraftContentState) =>
  DraftJS.EditorState.createWithContent(convertFromRaw(rawState))

export const textFromRawContentState = (rawState: DraftJS.RawDraftContentState) => {
  return DraftJS.EditorState.createWithContent(DraftJS.convertFromRaw(rawState))
    .getCurrentContent()
    .getPlainText()
}
